<template>
  <Footer
    :links="bottomLevelLinks"
    :column="mgnlProps.column"
    :brands="mgnlProps.brands"
    :category-links="mgnlProps.categoriesLinks"
  />
</template>

<script lang="ts" setup>
import { FooterBuilder, WrapperProps } from './Footer.model';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps(WrapperProps);
const mgnlProps = FooterBuilder.build(props);
const { $domain } = useNuxtApp();

provide('mobileDisplayMode', mgnlProps.mobileDisplayMode);
const bottomLevelLinks = mgnlProps.bottomLevelLinks?.map(topLevel => magnoliaGetters.getLinkAndName(topLevel, $domain.cmsAssetDomainPath, topLevel.switchable?.intLinkParam));
</script>
